import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '@fry/lib/guards';

import { RolesComponent } from '@fry/components/roles/roles/roles.component';
import { RoleListComponent } from '@fry/components/roles/role-list/role-list.component';
import { RoleAddComponent } from '@fry/components/roles/role-add/role-add.component';
import { RoleEditComponent } from '@fry/components/roles/role-edit/role-edit.component';
import { RoleDuplicateComponent } from '@fry/components/roles/role-duplicate/role-duplicate.component';
import { RoleResolver } from '@fry/components/roles/role.resolver';

const routes: Routes = [
  {
    path: '',
    component: RolesComponent,
    canActivate: [
      AuthGuard
    ],
    children: [
      {
        path: '',
        component: RoleListComponent,
        canActivate: [
          AuthGuard
        ],
        data: {
          requiredPermissions: ['roles.view']
        }
      },
      {
        path: 'add',
        component: RoleAddComponent,
        canActivate: [
          AuthGuard
        ],
        data: {
          requiredPermissions: ['roles.edit']
        }
      },
      {
        path: ':id/edit',
        component: RoleEditComponent,
        canActivate: [
          AuthGuard
        ],
        resolve: {
          role: RoleResolver
        },
        data: {
          requiredPermissions: ['roles.edit']
        }
      },
      {
        path: ':id/duplicate',
        component: RoleDuplicateComponent,
        canActivate: [
          AuthGuard
        ],
        resolve: {
          role: RoleResolver
        },
        data: {
          requiredPermissions: ['roles.edit']
        }
      }
    ]
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [
    RoleResolver
  ]
})
export class RolesRoutingModule { }
